export default __webpack_public_path__ + "static/media/04.bbc0b9bf.png";